import React from "react";

import CompanyLogo from "./assets/images/company_logo.png";

const PageNotFound: React.FC = () => {
  return (
    <section className={`page product-ruby`}>
      <div className="page-toolbar">
        <img src={CompanyLogo} alt="Meet Parker" height={80} />
      </div>
      <div className="page-content not-found">
        <h1>Page is gone/missing</h1>
        <p>404 : missing page you might want to</p>
      </div>
      <div className="page-background">
        <div className="page-cloud-1" />
        <div className="page-airplane" />
        <div className="page-cloud-2" />
      </div>
    </section>
  );
};

export default React.memo(PageNotFound);
